import { React, useEffect, useState } from "react";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
  ProductionSet,
} from "../../../../../src/Pages/styledElements";
import {
  Button,
  Form,
  Input,
  Select,
  Col,
  Row,
  Checkbox,
  Tooltip,
  DatePicker,
} from "antd";
import Iconmoon from "../../../../Components/IconsFiles/icon";
import RightDrawerSidebar from "../../../../Components/RightDrawer/rightDrawer";
import { DatePickerY } from "../../../../../src/Pages/pageStyled";
import moment from "moment";
import { getProductionOrderDetails } from "../../../../Services/productionPlanningServices";
import {
  lengthUnit,
  weightUnit,
} from "../../../../Utils/Constant/MeasurementUnitList";
const { Option } = Select;

const OrderDrawer = (props) => {
  const [form] = Form.useForm();
  const orderTypeData = ["Sheet", "Reel"];
  const [details, setDetails] = useState();

  const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);

  const showProductionStatus = (status) => {
    return capitalize(
      status === "open"
        ? "Not Mapped"
        : status === "cancel"
        ? "Cancelled"
        : status
    );
  };

  const hcDate = {
    dateOfBirth: moment("2020-06-09T12:40:14+0000"),
  };

  const [validateData, setValidateData] = useState({
    type: "",
    price: "",
    weight: "",
  });

  const deckleWidthUnitData = ["mm", "cm"];

  const handleType = (e) => {
    setValidateData({ ...validateData, type: e });
  };

  useEffect(() => {
    form.resetFields();
    if (props.id) {
      getProductionOrderDetails(props.id)
        .then((response) => setDetails(response.data.data))
        .catch((error) => console.log(error));
    }
    return () => setDetails();
  }, [props]);

  return details ? (
    <RightDrawerSidebar
      title={`Order - ${details.number}`}
      subtitle=""
      visible={props.visible}
      onClose={() => {
        props.onCloseOrderDrawer();
        form.resetFields();
      }}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          <DetailFields className="marginBtnP">
            <HaberForm>
              <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "0" }}
              >
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Order Type</h5>
                    <p>Original text need to place here</p>
                  </div>
                  <Form.Item
                    name="Order type"
                    rules={[{ required: true }]}
                    className=""
                    initialValue={capitalize(details.type)}
                  >
                    <Input disabled placeholder="Order Type" />
                  </Form.Item>
                </div>
                <div className="drawerField removeStar">
                  <div className="titleWithText">
                    <h5>Order Dimension</h5>
                    <p>
                      {details.type === "reel" ? (
                        <>The width of the order</>
                      ) : (
                        <>The width and length of the order</>
                      )}
                    </p>
                  </div>
                  <Row className="centerAlign justifyCSBetween">
                    {details.type !== "reel" && (
                      <Col span={8}>
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <Form.Item
                            // label="Length"
                            name="length"
                            rules={[
                              {
                                required:
                                  details.type !== "reel" ? true : false,
                              },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                                message:
                                  "Upto 2 decimal point values is accepted",
                              },
                            ]}
                            className="dBlock"
                            initialValue={details.length}
                            style={{ marginBottom: "0px" }}
                          >
                            <Input
                              //placeholder="Length"
                              disabled
                            />
                          </Form.Item>{" "}
                          <p>Length</p>
                        </div>
                      </Col>
                    )}
                    <Col span={details.type !== "reel" ? 8 : 14}>
                      <div className="boxFormType">
                        <Form.Item
                          // label="Width"
                          name="width"
                          rules={[
                            { required: true },
                            {
                              pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                              message:
                                "Upto 2 decimal point values is accepted",
                            },
                          ]}
                          className="dBlock"
                          initialValue={details.width}
                          style={{ marginBottom: "0px" }}
                        >
                          <Input placeholder="Width" disabled />
                        </Form.Item>{" "}
                        <p>Width</p>
                      </div>
                    </Col>
                    <Col span={details.type !== "reel" ? 7 : 9}>
                      <div className="boxFormType unitSelect">
                        <Form.Item
                          // label="Unit"
                          name="dimension-unit"
                          rules={[{ required: true }]}
                          className="dBlock"
                          initialValue={
                            details?.units?.width
                              ? lengthUnit[
                                  details?.units?.width
                                ]?.displayName?.toUpperCase()
                              : "CM"
                          }
                          style={{ marginBottom: "0px" }}
                        >
                          <Select
                            placeholder="Unit"
                            suffixIcon={<DownArrowDraw />}
                            disabled
                          >
                            {deckleWidthUnitData.map((deckleWidth) => (
                              <Option
                                key={deckleWidth.value}
                                value={deckleWidth.value}
                              >
                                {deckleWidth}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>{" "}
                        <p style={{ paddingLeft: "5px" }}>Unit</p>
                      </div>
                    </Col>
                  </Row>
                </div>
                {/* <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Planned Weight</h5>
                    <p>Planned Weight of order</p>
                  </div>
                  <div style={{ position: "relative" }}>
                    <Form.Item
                      name="weight"
                      rules={[
                        { required: true },
                        {
                          pattern: new RegExp(/^\d+(\.\d+)?$/),
                          message: "Only decimal values possible",
                        },
                      ]}
                      className=""
                      initialValue={details.planned_weight.toFixed(2)}
                    >
                      <Input
                        //placeholder="Enter weight"
                        value={details.weight}
                        disabled
                      />
                    </Form.Item>
                    <span className="nonEditable">{details?.units?.planned_weight ? capitalize(weightUnit[details?.units?.planned_weight]?.displayName): "T"}</span>
                  </div>
                </div> */}
                <div className="drawerField removeStar">
                  <div className="titleWithText">
                    <h5>Order Quantity</h5>
                    <p>
                      The ordered and produced quantity details of the order
                    </p>
                  </div>
                  <Row className="centerAlign justifyCSBetween">
                    <Col span={12}>
                      <div
                        className="boxFormType"
                        style={{ marginBottom: "0" }}
                      >
                        <div style={{width: '100%', display: 'flex', alignItems: "center"}}>
                        <Form.Item
                          // label="Ordered Quantity"
                          name="planned"
                          className="dBlock"
                          initialValue={(
                            // details.quantity_type === "weight" ?
                              details.weight
                            // : details.no_of_reel_sheet
                          ).toFixed(3)}
                          style={{ marginBottom: "0px" }}
                        >
                          <Input
                            //placeholder="Length"
                            disabled
                          />
                        </Form.Item>
                        <span style={{right: '20px', position: 'absolute', color:'rgba(0, 0, 0, 0.45)'}}>{weightUnit[details.units?.weight]?.displayName?.toUpperCase()}</span>
                        </div>
                        <p>Ordered Quantity</p>
                      </div>
                    </Col>
                    <Col span={11}>
                      <div className="boxFormType">
                        <div style={{width: '100%', display: 'flex', alignItems: "center"}}>
                        <Form.Item
                          // label="Produced Quantity"
                          name="produced"
                          className="dBlock"
                          initialValue={(
                            // details.quantity_type === "weight" ?
                              details.produced_weight
                            // : details.produced_quantity
                          ).toFixed(3)}
                          style={{ marginBottom: "0px" }}
                        >
                          <Input placeholder="Produced" disabled />
                        </Form.Item>{" "}
                        <span style={{right: '20px', position: 'absolute', color:'rgba(0, 0, 0, 0.45)'}}>{weightUnit[details.units?.weight]?.displayName?.toUpperCase()}</span>
                        </div>
                        <p>Produced Quantity</p>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Delivery Date</h5>
                    <p>The order needs to be delivered on selected date</p>
                  </div>
                  <div className="boxFormType">
                    <DatePickerY>
                      <Form.Item
                        name="Date"
                        initialValue={moment(
                          details.delivery_date,
                          "YYYY-MM-DD"
                        )}
                      >
                        <DatePicker format={"DD-MM-YYYY"} disabled />
                      </Form.Item>
                    </DatePickerY>
                  </div>
                </div>
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Produced Reels</h5>
                    <p>The reels produced in this order can be viewed here</p>
                  </div>
                  <div className="prod-reelset">
                    {details.reels.map((reel) => (
                      <ProductionSet>
                        <div className="prodset-header">
                          <Iconmoon
                            icon={
                              details?.machine_type === "cutter"
                                ? "sheet"
                                : "tissue-role"
                            }
                            size={28}
                            color="#EA655B"
                          />
                          <div className="prodleft-header">
                            <h4>
                              {reel.id}
                              {reel.priority && (
                                <span dataset="Priority">Priority</span>
                              )}
                              {reel.intermediate_reels && (
                                <span
                                  style={{
                                    color: "#6a6866",
                                    backgroundColor: "#edebe9",
                                    marginTop: "auto",
                                  }}
                                >
                                  Intermediate
                                </span>
                              )}
                            </h4>
                            <label>
                              Delivery Date:{" "}
                              {moment(reel.delivery_date).format("DD-MM-YYYY")}
                            </label>
                          </div>
                        </div>
                        <div className="prodset-body">
                          <div className="prodset-dt">
                            <h5>PO NO.:</h5>
                            <p>{reel.po}</p>
                          </div>
                          <div className="prodset-dt">
                            <h5>ORDER NO.:</h5>
                            <p>{reel.order}</p>
                          </div>
                          <div className="prodset-dt">
                            <h5>JOB CARD NO.:</h5>
                            <p>{reel.jobcard}</p>
                          </div>
                          <div className="prodset-dt">
                            {details?.machine_type === "cutter" ? (
                              <h5>PARENT SET NO.:</h5>
                            ) : (
                              <h5>PARENT REEL NO.:</h5>
                            )}
                            <p>{reel.parent_reel}</p>
                          </div>
                          <div className="d-flex prodset-sb">
                            <div className="prodset-dt prod-50">
                              <h5>Weight:</h5>
                              <p>
                                {reel.weight.toFixed(3)}{" "}
                                {reel?.units?.weight
                                  ? capitalize(
                                      weightUnit[reel.units.weight]?.displayName
                                    )
                                  : "T"}
                              </p>
                            </div>
                            <div className="prodset-dt prod-50">
                              <h5>Size:</h5>
                              {details?.machine_type === "cutter" ? (
                                <p>
                                  {reel.length} x {reel.width}{" "}
                                  {reel?.units?.width
                                    ? lengthUnit[
                                        reel.units.width
                                      ]?.displayName?.toUpperCase()
                                    : "CM"}
                                </p>
                              ) : (
                                <p>
                                  {reel.width}{" "}
                                  {reel?.units?.width
                                    ? lengthUnit[
                                        reel.units.width
                                      ]?.displayName?.toUpperCase()
                                    : "CM"}
                                </p>
                              )}
                            </div>
                          </div>
                          {details?.machine_type === "cutter" && (
                            <div className="prodset-dt">
                              <h5>Produced Sheets:</h5>
                              <p>
                                {reel.accepted_no_of_sheets}
                                {""} {`(${reel.accepted_weight.toFixed(3)})`}{" "}
                                {reel?.units?.weight
                                  ? capitalize(
                                      weightUnit[reel.units.weight]?.displayName
                                    )
                                  : "T"}
                              </p>
                            </div>
                          )}
                          {details?.machine_type === "cutter" && (
                            <div className="prodset-dt">
                              <h5>Rejected Sheets:</h5>
                              <p>
                                {reel.rejected_no_of_sheets}
                                {""} {`(${reel.rejected_weight.toFixed(3)})`}{" "}
                                {reel?.units?.weight
                                  ? capitalize(
                                      weightUnit[reel.units.weight]?.displayName
                                    )
                                  : "T"}
                              </p>
                            </div>
                          )}
                        </div>
                        <div className="prodset-footer">
                          <label>Production Status</label>
                          <span dataset={showProductionStatus(reel.status)}>
                            {showProductionStatus(reel.status)}
                          </span>
                        </div>
                      </ProductionSet>
                    ))}
                  </div>
                </div>
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
      </RightDrawerContainer>
    </RightDrawerSidebar>
  ) : null;
};

export default OrderDrawer;
